type InputDevice = Pick<MediaDeviceInfo, 'deviceId' | 'kind'>;

export type InitialMediaChoices = {
  videoEnabled: boolean;
  audioEnabled: boolean;
  videoDeviceId: string;
  audioDeviceId: string;
};

export function getInitialMediaChoices(devices: InputDevice[]): InitialMediaChoices {
  const videoDevice = devices.find((device) => device.kind === 'videoinput');
  const audioDevice = devices.find((device) => device.kind === 'audioinput');

  return {
    videoEnabled: videoDevice !== undefined,
    audioEnabled: audioDevice !== undefined,
    videoDeviceId: videoDevice?.deviceId || 'default',
    audioDeviceId: audioDevice?.deviceId || 'default',
  };
}

export const disabledInitialMediaChoices: InitialMediaChoices = {
  videoEnabled: false,
  audioEnabled: false,
  videoDeviceId: 'default',
  audioDeviceId: 'default',
};
